import React from 'react';
import Grid from '@mui/material/Grid';
//import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import TopSalesBox from './TopSalesBox';
import Title from './Title';
import useStyles from './Styles';

interface TopFavsProps {
    favs:any,
    months: string[],
}

const TopFavs:React.FC<TopFavsProps> = (props)=> {
	const classes = useStyles();
	return (
        <Box style={{marginBottom:"4em"}}>
            <Title text="獲得したスキの数"/>
            <Grid container spacing={2}>
                <Grid item xs={6} md={3}>
                    <TopSalesBox title="今月" date={props.months[0]} primary={props.favs.month0} primaryUnit="個"/>
                </Grid>
                <Grid item xs={6} md={3}>
                    <TopSalesBox title="先月" date={props.months[1]} primary={props.favs.month1} primaryUnit="個"/>
                </Grid>
                <Grid item xs={6} md={3}>
                    <TopSalesBox title="先々月" date={props.months[2]} primary={props.favs.month2} primaryUnit="個"/>
                </Grid>
                <Grid item xs={6} md={3}>
                    <TopSalesBox title="通算" primary={props.favs.all} primaryUnit="個"/>
                </Grid>
            </Grid>
        </Box>
    );
}

export default TopFavs;
